import React, { Component } from 'react'

import './EventForm.css'

/**
 * Modules
 */
import { Form, Input, DatePicker, Button, message } from 'antd'
import TextArea from '../../../../node_modules/antd/lib/input/TextArea'
import moment from 'moment'
import { createEvent as sharedCreateEvent, updateEvent as sharedUpdateEvent } from '../../../utils/eventsFunctions';

class EventForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            champAddObjectFile: null,
            addButtonLoading: false,
            editButtonLoading: false,
            initialValue: [{}, {}, {}, {}],
            isUpdate: false,
            champToEdit: {},
        }
    }

    componentDidMount = () => {
        this.checkIfUpdate(this.props)
    }

    componentWillReceiveProps = (nextProps) => {
        this.checkIfUpdate(nextProps)
    }

    /* Method to check if form is to register or update */
    checkIfUpdate = (props) => {
        if (props.champToEdit) {
            this.setState({
                initialValue: [
                    { initialValue: props.champToEdit.nome },
                    { initialValue: props.champToEdit.descricao },
                    { initialValue: props.champToEdit.observacao },
                    { initialValue: moment(props.champToEdit.data) }
                ],
                isUpdate: true,
                champToEdit: props.champToEdit
            })
        }
    }

    chooseFile = () => {
        document.getElementById('selectChampFile').click()
    }

    getFile = (file) => {
        this.setState({
            champAddObjectFile: file.target.files[0]
        })
    }

    removeFile = () => {
        this.setState({
            champAddObjectFile: undefined
        })
    }

    createChamp = async (values) => {
        this.setState({ addButtonLoading: true })
        if (values.name) {
            let data = new Date(values.date).getTime()

            // Create champ in firebase
            const callbackCreatedEvent = await sharedCreateEvent({
                nome: values.name,
                descricao: values.description,
                data: data,
                observacao: values.obs,
                wasDeleted: false,
                momentOfCreation: new Date().getTime(),
                img: '',

                registrationStatus: 'inProgress',
                confrontationPerTime: 4,
                confrontationTime: 10,
                startChamp: 9
            },
                this.state.champAddObjectFile
            );

            if (!callbackCreatedEvent.error) {
                /* Clear form */
                this.props.form.resetFields();
                this.setState({
                    addButtonLoading: false,
                    champAddObjectFile: null
                });

                this.props.closeChampAddDialog();
            } else {
                this.setState({ addButtonLoading: false });
                message.error(callbackCreatedEvent.message);
            }
        } else {
            this.setState({ addButtonLoading: false })
            message.error('Nome do evento é obrigatório')
        }
    }

    editChamp = async (values) => {
        this.setState({ editButtonLoading: true })


        if (values.name) {

            let data = new Date(values.date).getTime()
            /* Update champ in firebase */
            const callbackUpdatedEvent = await sharedUpdateEvent(
                this.state.champToEdit.__key,
                {
                    nome: values.name,
                    descricao: values.description,
                    data: data,
                    observacao: values.obs,
                    wasDeleted: false,
                },
                this.state.champAddObjectFile,
                this.state.champAddObjectDoc,
            );

            if (!callbackUpdatedEvent.error) {
                /* Clear form */
                this.props.form.resetFields()
                this.setState({
                    editButtonLoading: false,
                    champAddObjectFile: null
                })

                this.props.closeChampEditDialog()
            } else {
                this.setState({ editButtonLoading: false });
                message.error(callbackUpdatedEvent.message);
            }
        } else {
            this.setState({ editButtonLoading: false })
            message.error('Nome do evento é obrigatório')
        }
    }

    render() {

        const { getFieldDecorator } = this.props.form

        return (
            <div>
                <Form>
                    <Form.Item>
                        {getFieldDecorator('name', this.state.initialValue[0])(
                            <Input placeholder='Nome do evento' className='sharedInput' />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('description', this.state.initialValue[1])(
                            <Input placeholder='Descrição do evento' className='sharedInput' />
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('obs', this.state.initialValue[2])(
                            <TextArea placeholder='Observações' rows={2} />
                        )}
                    </Form.Item>

                    <Form.Item style={{ float: 'left', width: '49%' }}>
                        {getFieldDecorator('date', this.state.initialValue[3])(
                            <DatePicker style={{ width: '100%' }} format='DD/MM/YYYY' placeholder='Data' />
                        )}
                    </Form.Item>

                    <input id='selectChampFile' type='file' style={{ display: "none" }} onChange={(input) => this.getFile(input)} />
                    {this.state.champAddObjectFile ?
                        <div className='sharedFileField' style={{ height: '31px', lineHeight: '31px', marginTop: '4px', marginLeft: '2%' }}>
                            {this.state.champAddObjectFile.name}
                            <div
                                className='sharedClearFileButton'
                                onClick={this.removeFile}
                            >X</div>
                        </div>
                        :
                        <Button
                            onClick={() => this.chooseFile()}
                            style={{ width: '49%', float: 'left', marginTop: '4px', marginLeft: '2%' }}
                            htmlType='button'
                        >
                            Enviar foto
                        </Button>
                    }

                    <div style={{ clear: 'both' }}></div>

                    {this.state.isUpdate ?
                        <Button
                            htmlType='button'
                            onClick={() => this.editChamp(this.props.form.getFieldsValue())}
                            type='primary'
                            style={{ width: '100%' }}
                            loading={this.state.editButtonLoading}
                        >
                            Atualizar
                        </Button>
                        :
                        <Button
                            htmlType='button'
                            onClick={() => this.createChamp(this.props.form.getFieldsValue())}
                            type='primary'
                            style={{ width: '100%' }}
                            loading={this.state.addButtonLoading}
                        >
                            Cadastrar
                        </Button>
                    }
                </Form>
            </div>
        )
    }

}

export default Form.create()(EventForm)